var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronFold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12.6016C17 12.6536 16.9904 12.7044 16.9712 12.7539C16.952 12.8034 16.9205 12.8464 16.8767 12.8828C16.7944 12.9609 16.6958 13 16.5807 13C16.4656 13 16.3669 12.9609 16.2847 12.8828L9 5.96875L1.72354 12.8828C1.64132 12.9609 1.54128 13 1.42343 13C1.30558 13 1.20555 12.9609 1.12333 12.8828C1.04111 12.8047 1 12.7109 1 12.6016C1 12.4922 1.04111 12.3984 1.12333 12.3203L8.70401 5.11719C8.78623 5.03906 8.88489 5 9 5C9.11511 5 9.21377 5.03906 9.29599 5.11719L16.8767 12.3203C16.9205 12.3568 16.952 12.3997 16.9712 12.4492C16.9904 12.4987 17 12.5495 17 12.6016Z",
    fill: "#6E7391",
    stroke: "#3D4453"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronFold);
export default __webpack_public_path__ + "static/media/chevron-fold.15cfb63093255f73dd2cc26ddbed8bd4.svg";
export { ForwardRef as ReactComponent };